// Central source of truth for business info, services, copy.
// NOTE: All legally-required strings below are VERBATIM per the compliance brief.
// Do not paraphrase, shorten, or reword.

export const BUSINESS = {
  name: "Rolling Stone Marketing",
  domain: "rollingstonemarketing.io",
  email: "alex@rollingstonemarketing.io",
  phone: "+1 (801) 515-0604",
  phoneHref: "tel:+18015150604",
  physicalAddress: "160 E. 300 S., 1st Floor, Salt Lake City, UT 84111",
  mailingAddress: "PO Box 146705, Salt Lake City, UT 84114-6705",
  hours: "Monday–Friday, 9:00 AM – 6:00 PM CT",
  state: "Utah",
};

export const SERVICES = [
  {
    id: "aged-data",
    title: "Aged Data",
    description:
      "Vetted aged lead inventory across verticals, filtered by geography, criteria, and age window.",
    tag: "Data Inventory",
  },
  {
    id: "web-scraping",
    title: "Web Scraping Services",
    description:
      "Custom collection from public web sources, with structured and deduplicated output delivered on a schedule.",
    tag: "Custom Extraction",
  },
  {
    id: "data-appending",
    title: "Data Appending",
    description:
      "Filling gaps in records the client already owns: phone, email, address, demographic and property attributes.",
    tag: "Enrichment",
  },
  {
    id: "marketing-consulting",
    title: "Marketing Consulting",
    description: "Offer, channel mix, funnel math, and follow-up strategy.",
    tag: "Advisory",
  },
  {
    id: "google-ads",
    title: "Google Ads",
    description:
      "Search and Performance Max builds, conversion tracking, and management against cost-per-acquisition targets.",
    tag: "Paid Search",
  },
  {
    id: "meta-marketing",
    title: "Facebook & Meta Marketing",
    description: "Creative, audience, and lead-form campaigns.",
    tag: "Paid Social",
  },
  {
    id: "prospect-flows",
    title: "Prospect Flows & Automations",
    description:
      "CRM pipelines, dialer and lead routing, speed-to-lead triggers, and multi-touch follow-up sequences.",
    tag: "Automation",
  },
  {
    id: "sales-app",
    title: "Sales App Development",
    description:
      "Custom sales and lead-flow applications — pipelines, dashboards, dialers, and routing built around how your team actually sells.",
    tag: "Product",
  },
  {
    id: "web-development",
    title: "Website Development",
    description:
      "Fast, conversion-focused websites and landing pages wired to your CRM and tracking from day one.",
    tag: "Web",
  },
];

export const STEPS = [
  {
    step: "01",
    title: "Scope & Target",
    description:
      "We map your ideal customer profile, define the verticals and geographies that matter, and audit the data you already own.",
  },
  {
    step: "02",
    title: "Source & Enrich",
    description:
      "We source aged inventory, stand up custom scrapes, and append the missing phone, email, address, and demographic fields.",
  },
  {
    step: "03",
    title: "Acquire",
    description:
      "We build and manage Google and Meta campaigns against clear cost-per-acquisition targets with proper conversion tracking.",
  },
  {
    step: "04",
    title: "Automate to Booked",
    description:
      "We wire CRM pipelines, lead routing, and speed-to-lead follow-up so a first touch turns into a booked appointment.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Data is the demand layer.",
    body: "Campaigns fail on bad lists long before they fail on bad creative. We start with sourcing, enrichment, and hygiene so everything downstream has something real to work with.",
  },
  {
    n: "02",
    title: "Speed-to-lead is the whole game.",
    body: "The first minutes after intent decide the outcome. We build the routing, dialers, and triggers that put a rep or a message in front of a prospect while they are still paying attention.",
  },
  {
    n: "03",
    title: "One operator, end to end.",
    body: "Data, paid acquisition, and automation are one system, not three vendors. We own the whole path from first touch to booked appointment so nothing falls through the seams.",
  },
];

// ---- VERBATIM COMPLIANCE STRINGS ----

export const SMS_CONSENT_TEXT =
  "Yes, text me. By checking this box, I agree to receive recurring marketing and customer care text messages from Rolling Stone Marketing at the mobile number provided above, including messages sent by an automatic telephone dialing system. Message frequency varies (approximately 2-6 messages per month). Message and data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out or HELP for help. See our Privacy Policy and Terms & Conditions.";

export const EMAIL_CONSENT_TEXT =
  "Email me too. I agree to receive marketing emails from Rolling Stone Marketing. I can unsubscribe at any time using the link in any email.";

export const FORM_NOTE =
  "Submitting this form does not require you to opt in to text messages. We will use the information you provide to respond to your inquiry. We do not sell or share website visitor information, mobile phone numbers, or SMS opt-in data with any third parties.";

export const FOOTER_SMS_DISCLOSURE =
  "SMS Disclosure: Rolling Stone Marketing sends recurring marketing and customer care text messages only to individuals who opt in via the optional checkbox on this website. Message frequency varies (approximately 2-6 messages per month). Message and data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out or HELP for help. No mobile information will be shared with third parties or affiliates for marketing or promotional purposes.";

export const INTEREST_OPTIONS = [
  ...SERVICES.map((s) => s.title),
  "Something else",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1704354428728-24b8ccab5c3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxkYXJrJTIwYWJzdHJhY3QlMjBkYXRhJTIwbmV0d29yayUyMG5vZGVzJTIwZ29sZHxlbnwwfHx8YmxhY2t8MTc4ODMwNDM1MXww&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.unsplash.com/photo-1713638394242-9edf9cf943cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXJrJTIwb2ZmaWNlJTIwd29ya3NwYWNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHxibGFja3wxNzg4MzA0MzUwfDA&ixlib=rb-4.1.0&q=85",
};
